// React
import React from 'react';
// Styles
import './styles.scss';

/**
 * @param {string} props.title - The text to be display as title
 */
const HeaderDivider = (props) => (
    <div className={`header-divider ${props.className ? props.className : ''}`}>
        <p className="header">{props.title}</p>
        <hr className="table-divider" />
    </div>
);

export default HeaderDivider;
